import { createFileRoute } from '@tanstack/react-router';

import { ApiAndWebhooksPage } from '@/areas/external-api/ApiAndWebhooks';
import { canViewOtherOrganizationSettings } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/settings/_menu/organization/api-integration')({
    staticData: {
        access: { permissions: canViewOtherOrganizationSettings },
        chrome: 'home',
    } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    return <ApiAndWebhooksPage />;
}
